namespace RioERP.Products {
    export interface ProductSpecificationsBooksForm {
        BookId: Serenity.LookupEditor;
        ProductSpecificationId: Serenity.IntegerEditor;
        InsertUserId: Serenity.IntegerEditor;
        InsertDate: Serenity.DateEditor;
        UpdateUserId: Serenity.IntegerEditor;
        UpdateDate: Serenity.DateEditor;
        IsActive: Serenity.BooleanEditor;
    }

    export class ProductSpecificationsBooksForm extends Serenity.PrefixedContext {
        static formKey = 'Products.ProductSpecificationsBooks';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProductSpecificationsBooksForm.init)  {
                ProductSpecificationsBooksForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DateEditor;
                var w3 = s.BooleanEditor;

                Q.initFormType(ProductSpecificationsBooksForm, [
                    'BookId', w0,
                    'ProductSpecificationId', w1,
                    'InsertUserId', w1,
                    'InsertDate', w2,
                    'UpdateUserId', w1,
                    'UpdateDate', w2,
                    'IsActive', w3
                ]);
            }
        }
    }
}
